import { gql } from '@apollo/client';

export const CampaignPostingQuery = gql`
  query CampaignPosting($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      requiredMetadata
      postingConfiguration {
        delay
        sameDay
        limits {
          fri
          mon
          sat
          thu
          sun
          tue
          wed
        }
      }
    }
  }
`;

export const CampaignPostingConfigUpdateMutation = gql`
  mutation CampaignPostingConfigUpdate(
    $campaignPostingConfigUpdateData: CampaignPostingConfigUpdateInput!
  ) {
    campaignPostingConfigUpdate(campaignPostingConfigUpdateData: $campaignPostingConfigUpdateData) {
      message
    }
  }
`;

export const CampaignRequiredMetadataUpdateMutation = gql`
  mutation CampaignRequiredMetadataUpdate(
    $campaignRequiredMetadataUpdateData: CampaignRequiredMetadataUpdateInput!
  ) {
    campaignRequiredMetadataUpdate(
      campaignRequiredMetadataUpdateData: $campaignRequiredMetadataUpdateData
    ) {
      message
    }
  }
`;
